/* Preserve a header drawer request until the previous drawer releases focus. */
(()=>{
 const ids=new Set(['menu-drawer','search-drawer']);
 const opening=new Set(),closing=new Set(),pointerStyles=new WeakMap();
 const pointerElements=target=>[target,...(target.shadowRoot?.querySelectorAll('*')||[])];
 const restorePointer=target=>{pointerElements(target).forEach(element=>{const style=pointerStyles.get(element);if(!style)return;if(style.value)element.style.setProperty('pointer-events',style.value,style.priority);else element.style.removeProperty('pointer-events');pointerStyles.delete(element);});};
 let pending=null,searchEscape=false,generation=0;
 const flush=()=>{
  if(!pending||opening.size||closing.size)return;
  const request=pending;pending=null;const ticket=++generation;
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
   if(ticket!==generation||!request.control.isConnected)return;
   const target=document.getElementById(request.id);
   if(!target||typeof target.show!=='function'||target.hasAttribute('open'))return;
   if(Array.from(ids).some(id=>id!==request.id&&document.getElementById(id)?.hasAttribute('open')))return;
   target.show({activator:request.control});
  }));
 };
 document.addEventListener('dialog:before-show',event=>{
  if(ids.has(event.target.id)){restorePointer(event.target);opening.add(event.target.id);}
 },true);
 document.addEventListener('dialog:after-show',event=>{
  const id=event.target.id;if(!ids.has(id))return;opening.delete(id);
  if(id==='search-drawer'&&searchEscape){searchEscape=false;queueMicrotask(()=>{if(event.target.hasAttribute('open'))event.target.hide();});return;}
  if(pending&&pending.id!==id){queueMicrotask(()=>{if(event.target.hasAttribute('open'))event.target.hide();});return;}
  flush();
 },true);
 document.addEventListener('dialog:before-hide',event=>{
  if(ids.has(event.target.id)){closing.add(event.target.id);pointerElements(event.target).forEach(element=>{pointerStyles.set(element,{value:element.style.getPropertyValue('pointer-events'),priority:element.style.getPropertyPriority('pointer-events')});element.style.setProperty('pointer-events','none','important');});}
 },true);
 document.addEventListener('dialog:after-hide',event=>{
  const id=event.target.id;if(!ids.has(id))return;
  restorePointer(event.target);closing.delete(id);opening.delete(id);if(id==='search-drawer')searchEscape=false;flush();
 },true);
 document.addEventListener('click',event=>{
  const control=event.target instanceof Element?event.target.closest('button[aria-controls]'):null;
  const id=control?.getAttribute('aria-controls');if(!ids.has(id))return;
  const otherId=id==='menu-drawer'?'search-drawer':'menu-drawer';
  const other=document.getElementById(otherId);
  if(!other||(!other.hasAttribute('open')&&!opening.has(otherId)&&!closing.has(otherId)))return;
  event.preventDefault();event.stopImmediatePropagation();++generation;
  pending={id,control};
  if(other.hasAttribute('open')&&!opening.has(otherId)&&!closing.has(otherId))other.hide();
 },true);
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape'||event.isComposing||event.defaultPrevented)return;
  if(!opening.has('search-drawer')||!document.getElementById('search-drawer')?.hasAttribute('open'))return;
  event.preventDefault();event.stopImmediatePropagation();searchEscape=true;
 },true);
})();

/* Preserve native drawers, focus handling and existing chat visibility. */
(()=>{if(window.__ohMenuLayers)return;window.__ohMenuLayers=true;
const saved=new Map();let wasOpen=false;let keyboardActivation=false;
let opening=false;let closing=false;let queuedClose=false;let queuedOpener=null;
document.addEventListener('dialog:before-show',event=>{if(event.target.id==='menu-drawer'){opening=true;queuedClose=false;if(window.matchMedia('(max-height:600px)').matches){const reset=()=>{if(event.target.hasAttribute('open'))event.target.querySelectorAll('header-menu-drawer-panel').forEach(panel=>{panel.scrollTop=0;});};reset();requestAnimationFrame(reset);}}},true);
document.addEventListener('dialog:after-show',event=>{if(event.target.id!=='menu-drawer')return;opening=false;queueMicrotask(()=>{if(queuedClose&&event.target.open&&!closing){queuedClose=false;event.target.hide();}});},true);
document.addEventListener('dialog:before-hide',event=>{if(event.target.id==='menu-drawer')closing=true;},true);
document.addEventListener('dialog:after-hide',event=>{if(event.target.id!=='menu-drawer')return;closing=false;opening=false;queuedClose=false;const activator=queuedOpener;queuedOpener=null;if(activator)requestAnimationFrame(()=>requestAnimationFrame(()=>{if(!event.target.open&&!closing)event.target.show({activator});}));},true);
// Keyboard activation must enter the menu even on touch-capable screens.
document.addEventListener('click',event=>{
 const control=event.target instanceof Element?event.target.closest('[aria-controls="menu-drawer"]'):null;
 if(!control)return;
 if(closing){event.preventDefault();event.stopImmediatePropagation();queuedOpener=control;keyboardActivation=event.detail===0;return;}
 if(opening){event.preventDefault();event.stopImmediatePropagation();queuedClose=true;return;}
 if(!document.getElementById('menu-drawer')?.hasAttribute('open'))keyboardActivation=event.detail===0;
},true);
// Native focus-trap listeners wait for the opening animation. Keep Escape usable during that interval.
document.addEventListener('keydown',event=>{
 if(event.key!=='Escape'||event.defaultPrevented||event.isComposing)return;
 const menu=document.getElementById('menu-drawer');if(!menu?.hasAttribute('open')||typeof menu.hide!=='function')return;
 // A country/language dialog controlled from this menu owns its own Escape handling.
 const controls=Array.from(menu.querySelectorAll('[aria-controls]'));
 const nested=Array.from(document.querySelectorAll('[role="dialog"][open],dialog[open]')).some(dialog=>dialog!==menu&&controls.some(control=>control.getAttribute('aria-controls')===dialog.id));
 if(nested)return;
 event.preventDefault();if(opening)queuedClose=true;else menu.hide();
});
// Native panel animations hide the opener; keep keyboard focus in the newly visible panel.
const panelOpeners=new Map();
const focusPanel=(panel,preferred)=>{
 const visible=el=>el&&el.getClientRects().length&&!el.closest('[hidden],[inert]')&&getComputedStyle(el).visibility!=='hidden';
 const target=visible(preferred)?preferred:Array.from(panel.querySelectorAll('a[href],button:not(:disabled),summary,[tabindex="0"]')).find(visible);
 target?.focus({preventScroll:true});
};
document.addEventListener('click',event=>{
 if(event.detail!==0)return;
 const control=event.target instanceof Element?event.target.closest('[data-panel-toggle][aria-controls]'):null;
 const menu=document.getElementById('menu-drawer');if(!control||!menu?.hasAttribute('open')||!menu.contains(control))return;
 const panel=document.getElementById(control.getAttribute('aria-controls'));
 if(!panel||!menu.contains(panel)||!panel.classList.contains('is-visible'))return;
 const from=control.closest('header-menu-drawer-panel');
 if(panel.hasAttribute('data-main-panel'))focusPanel(panel,panelOpeners.get(from?.id));
 else{panelOpeners.set(panel.id,control);focusPanel(panel);}
});
// Preserve the latest panel action while the native theme finishes its transition.
let queuedPanelControl=null,queuedPanelDetail=0,panelQueueScheduled=false;
const flushPanelAction=menu=>{
 if(!menu?.hasAttribute('open')){queuedPanelControl=null;return;}
 if(!queuedPanelControl||panelQueueScheduled||menu.querySelectorAll('header-menu-drawer-panel.is-visible').length!==1)return;
 panelQueueScheduled=true;
 requestAnimationFrame(()=>requestAnimationFrame(()=>{
  panelQueueScheduled=false;
  if(!menu.hasAttribute('open')){queuedPanelControl=null;return;}
  if(menu.querySelectorAll('header-menu-drawer-panel.is-visible').length!==1)return;
  const control=queuedPanelControl,detail=queuedPanelDetail;queuedPanelControl=null;
  if(control?.isConnected&&control.closest('header-menu-drawer-panel')?.classList.contains('is-visible'))control.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true,detail}));
 }));
};
document.addEventListener('click',event=>{
 const control=event.target instanceof Element?event.target.closest('[data-panel-toggle][aria-controls]'):null;
 const menu=document.getElementById('menu-drawer');
 if(!control||!menu?.hasAttribute('open')||!menu.contains(control)||menu.querySelectorAll('header-menu-drawer-panel.is-visible').length<2)return;
 event.preventDefault();event.stopImmediatePropagation();queuedPanelControl=control;queuedPanelDetail=event.detail;
},true);
// Panel routes reveal navigation content; they are disclosures, not ARIA menus.
const observedMenus=new WeakSet();
const syncPanelDisclosures=menu=>{
 if(!menu)return;
 menu.querySelectorAll('[data-panel-toggle][aria-controls]:not(.back-button)').forEach(control=>{
  const panel=document.getElementById(control.getAttribute('aria-controls'));
  if(!panel||!menu.contains(panel))return;
  control.removeAttribute('aria-haspopup');
  control.setAttribute('aria-expanded',String(menu.hasAttribute('open')&&panel.classList.contains('is-visible')));
 });
 flushPanelAction(menu);
 if(observedMenus.has(menu))return;
 observedMenus.add(menu);
 new MutationObserver(changes=>{if(changes.some(change=>change.type==='childList'||change.target.tagName==='HEADER-MENU-DRAWER-PANEL'))syncPanelDisclosures(menu);}).observe(menu,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
};
// Desktop navigation also owns the foreground until its exit animation completes.
const closingDesktopMenus=new WeakSet();
const syncDesktopLayer=()=>{
 const foreground=Array.from(document.querySelectorAll('x-header.header header-mega-menu,x-header.header header-dropdown-menu')).some(panel=>(panel.hasAttribute('open')||closingDesktopMenus.has(panel))&&panel.getClientRects().length&&getComputedStyle(panel).visibility!=='hidden');
 document.documentElement.classList.toggle('oh-desktop-menu-layer-open',foreground);
};
['dialog:before-show','dialog:after-show','dialog:before-hide','dialog:after-hide'].forEach(name=>document.addEventListener(name,event=>{
 const panel=event.target;if(!(panel instanceof Element)||!panel.matches('header-mega-menu,header-dropdown-menu')||!panel.closest('x-header.header'))return;
 if(name==='dialog:before-hide')closingDesktopMenus.add(panel);
 else closingDesktopMenus.delete(panel);
 syncDesktopLayer();
},true));
window.addEventListener('resize',()=>requestAnimationFrame(syncDesktopLayer));
const sync=()=>{syncDesktopLayer();const menu=document.getElementById('menu-drawer');syncPanelDisclosures(menu);if(menu&&!menu.hasAttribute('aria-label'))menu.setAttribute('aria-label',document.documentElement.lang.startsWith('es')?'Menú':'Menu');const open=!!menu?.hasAttribute('open');document.documentElement.classList.toggle('oh-menu-layer-open',open);
if(open&&!wasOpen){
 if(keyboardActivation){
  const panel=menu.querySelector('[data-main-panel]')||menu;
  const target=Array.from(panel.querySelectorAll('a[href],button:not(:disabled),summary,[tabindex="0"]')).find(el=>el.getClientRects().length&&!el.closest('[hidden],[inert]')&&getComputedStyle(el).visibility!=='hidden');
  target?.focus({preventScroll:true});
 }
 keyboardActivation=false;
 document.querySelectorAll('.oh-collection-filter__panel[aria-hidden="false"] .oh-collection-filter__close').forEach(button=>button.click());document.querySelectorAll('.facets-drawer[open],.oh-native-tag-drawer[open]').forEach(panel=>{if(typeof panel.hide==='function')panel.hide();});const legacy=document.querySelector('#oh-tagsheet');if(legacy?.classList.contains('is-open'))legacy.querySelector('[data-oh-tagclose]')?.click();}
if(open){document.querySelectorAll('main,shopify-chat,.oh-tagm-btn,.oh-tagm-scrim').forEach(el=>{if(!saved.has(el))saved.set(el,el.inert);el.inert=true;});}else{saved.forEach((inert,el)=>{el.inert=inert;});saved.clear();}wasOpen=open;};
const start=()=>{new MutationObserver(sync).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open']});sync();};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();})();
